import { push } from "connected-react-router";
import React from "react";
import { connect } from "react-redux";
import { reduxForm, clearSubmitErrors } from "redux-form";
import AuthService from "../../services/auth";
import { authorizationActionCreators } from "../../store/actions/authorization";
import Form from "./Form";
import formName from "./formName";

const ReduxForm = reduxForm({
  formName,
  form: formName,
  onChange: (values, dispatch, props) => {
    if (props.error) dispatch(clearSubmitErrors(formName));
  },
})(Form);

export default connect(
  state => ({
    initialValues: {
      phone: state.authorization.phone,
    },
  }),
  (dispatch) => ({
    goBack: () => {
      dispatch(authorizationActionCreators.setPhoneNumber());
      dispatch(push("/login/auth"));
    },
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    resendSMS: () => AuthService.login({ phone: stateProps.initialValues.phone }),
  }))(ReduxForm);
